import '../../ieConfig/MobxConfig'
import { Instance, types } from 'mobx-state-tree'

const Client = types
  .model('Client', {
    clientId: types.optional(types.number, 0),
    ipaddress: types.optional(types.string, ''),
    macaddress: types.optional(types.string, ''),
    deviceid: types.optional(types.string, ''),
    devicetype: types.optional(types.string, 'DESKTOP'),
    deviceInfo: types.optional(types.string, ''),
    latitude: types.optional(types.string, ''),
    longitude: types.optional(types.string, ''),
  })
  .actions((self) => ({
    updateClientId(clientId: number): void {
      self.clientId = clientId
    },
  }))

const ClientInitalData = Client.create({
  clientId: 0,
})

export type ClientType = Instance<typeof Client>
export { Client, ClientInitalData }
